import {NgModule} from '@angular/core';
import { NgxFileDropModule } from 'ngx-file-drop';
import {SwiperModule} from 'swiper/angular';
import {NgxPrintModule} from "ngx-print";
import {NpnSliderModule} from "npn-slider";
import {NgSelectModule} from "@ng-select/ng-select";
import {MatTreeSelectInputModule} from "mat-tree-select-input";
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';

import {ClipboardModule} from "@angular/cdk/clipboard";


const extraDesignModule = [
    NgxFileDropModule,
    SwiperModule,
    NgxPrintModule,
    NpnSliderModule,
    NgSelectModule,
    MatTreeSelectInputModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    ClipboardModule

]

@NgModule({
    imports: [
        extraDesignModule
    ],
    exports: [
        extraDesignModule
    ]
})
export class ExtraDesignModule {
}
